import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Variables } from "../../Variables1/Variables";
import validator from "validator";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  Row,
  Col,
  Image,
  Form,
  Button,
  Spinner,
  FormCheck,
} from "react-bootstrap";
import Multiselect from "multiselect-react-dropdown";
import { Card } from "react-bootstrap";
import { Link } from "react-router-dom";
import CustomSnipper from "../../components/customSnipper";
import Util from "../../Classes/Util";
import axios from "axios";
import { DatePicker, Space } from "antd";
import { getDay, getMonth, getYear, isValid } from "date-fns";
import Cookies from "js-cookie";

function ManageContent(props) {
  const ContentRouteId = useParams();
  const navigate = useNavigate();
  const token = Cookies.get("token");
  const [Permissions, setPermissions] = useState(
    Util.decrypt(localStorage.getItem("rpmRRTLx12"))
  );

  const [contentId, setContentId] = useState(
    Number(ContentRouteId.ContentRouteId) || 0
  );

  const [loader, setLoader] = useState(false);
  const [buttonLoader, setButtonLoader] = useState(false);

  const [contentExist, setContentExist] = useState(null);

  //#region Language

  const [languages, setLanguages] = useState([]);

  // Get Languages
  const GetLanguages = async () => {
    let response = await fetch(Variables.API_URL + "Language/GetLanguages", {
      method: "GET",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    let result = await response.json();
    if (response.status === 200) {
      setLanguages(result);
    }
  };
  //#endregion

  //#region Menu

  const [menus, setMenus] = useState([]);

  // Get Menus
  const GetMenus = async () => {
    let response = await fetch(Variables.API_URL + "Menu/GetMenusForDdl", {
      method: "GET",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    let result = await response.json();
    if (response.status === 200) {
      setMenus(result);
    }
  };

  //#endregion

  //#region Authors

  const [authors, setAuthors] = useState([]);

  // Get Authors
  const GetAuthors = async () => {
    let response = await fetch(Variables.API_URL + "Author/GetAuthorsList", {
      method: "GET",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    let result = await response.json();
    if (response.status === 200) {
      setAuthors(result);
    }
  };

  //#endregion

  //#region Albums

  const [albums, setAlbums] = useState([]);

  // Get Albums
  const GetAlbums = async () => {
    let response = await fetch(Variables.API_URL + "Album/GetAllAlbums", {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    });
    let result = await response.json();
    if (response.status === 200) {
      setAlbums(result);
    }
  };

  //#endregion

  //#region Widgets

  const [widgets, setWidgets] = useState([]);
  const [selectedWidgets, setSelectedWidgets] = useState([]);

  // Get Widgets
  const GetWidgets = async () => {
    let response = await fetch(Variables.API_URL + "Widget/GetWidgets", {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    });
    let result = await response.json();
    if (response.status === 200) {
      setWidgets(result);
    }
  };

  // Get Widgets
  const GetSelectedWidgets = async () => {
    let response = await fetch(
      Variables.API_URL + "Content/GetContentWidgets/" + contentId,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      }
    );
    let result = await response.json();
    if (response.status === 200) {
      setSelectedWidgets(result);
    }
  };

  // handle select Widgets
  const handleAssignWdgets = (e) => {
    setSelectedWidgets(e);
    if (e.length > 0) {
      var element = document.getElementById("SelectedWidgets").childNodes[0];
      element.classList.remove("required");
    }
  };

  //#endregion

  //#region custom fields

  const [types, setTypes] = useState([]);
  const [selectedTypes, setSelectedTypes] = useState([]);
  const [customData, setCustomData] = useState([]);

  // Get Types
  const GetTypes = async () => {
    let response = await fetch(
      Variables.API_URL + "CustomFieldType/GetAllCustomFieldTypes",
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      }
    );
    let result = await response.json();
    if (response.status === 200) {
      console.log(result);
      setTypes(result);
    }
  };

  // Get selected Types
  const GetSelectedTypes = async () => {
    let response = await fetch(
      Variables.API_URL + "Content/GetContentSelectedCustomFieldTypes/" + contentId,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      }
    );
    let result = await response.json();
    if (response.status === 200) {
      console.log(result);
      setSelectedTypes(result);
    }
    else { setSelectedTypes([]) }
  };

  // handle select Type
  const handleSelectType = async (selectedList) => {
    const newTypes = selectedList.filter(
      (newType) =>
        !selectedTypes.some(
          (oldType) => oldType.CustomFieldTypeId === newType.CustomFieldTypeId
        )
    );

    const newTypesWithData = await Promise.all(
      newTypes.map(async (newType) => {
        const response = await fetch(
          Variables.API_URL +
          "CustomFieldData/GetCustomFieldTypeData/" +
          newType.CustomFieldTypeId
        );
        const result = await response.json();
        return {
          CustomFieldTypeId: newType.CustomFieldTypeId,
          Text: newType.Text,
          SelectedData: 0,
          Data: result,
        };
      })
    );

    setSelectedTypes([...selectedTypes, ...newTypesWithData]);
  };

  // handle Remove Type
  const handleRemoveType = (e) => {
    var x = [...selectedTypes];
    let counter = 0;

    selectedTypes.forEach((type) => {
      let exist = false;
      e.forEach((element) => {
        if (element.CustomFieldTypeId == type.CustomFieldTypeId) {
          exist = true;
        }
      });

      if (exist == false) {
        x.splice(counter, 1);
      }
      counter++;
    });
    setSelectedTypes(x);
  };

  //handle Select Custum Data
  const handleSelectCustumData = (e, index) => {
    const { name, value } = e.target;

    var copy = [...selectedTypes];
    var toUpdate = copy[index];
    toUpdate.SelectedData = value;
    setSelectedTypes(copy);

    if (value == 0) {
      var element = document.getElementById("CustomFieldData" + index);
      element.classList.add("is-invalid");
    }
    else {
      var element = document.getElementById("CustomFieldData" + index);
      element.classList.remove("is-invalid");
    }
  };

  //#endregion

  //#region content Details

  function GetCurrentDate(y) {
    var x = new Date(y);
    var year = "";
    year = x.getFullYear();
    var month = "";
    if (x.getMonth() < 10) {
      month = "0" + x.getMonth();
    } else {
      month = x.getMonth();
    }

    var day = "";
    if (x.getMonth() < 10) {
      day = "0" + x.getDay();
    } else {
      day = x.getDay();
    }
    var p = year + "-" + month + "-" + day;
    return p;
  }

  var currentDate = GetCurrentDate();

  const [contentDetails, setContentDetails] = useState({
    ContentId: 0,
    Title: "",
    SubTitle: "",
    Date: "",
    MenuId: 0,
    AlbumId: 0,
    HasEventDate: false,
    EventStartDate: new Date(),
    EventEndDate: new Date(),
    Description: "",
    SmallDescription: "",
    IsPublished: true,
    ImageUrl: "",
    ThumbnailUrl: "",
    AuthorId: 1,
    LanguageId: 1,
    ReferenceNumber: "",
    Dimension: "",
  });
  const [image, setImage] = useState("");
  const [imageToDb, setImageToDb] = useState("");

  const [thumbnail, setThumbnail] = useState("");
  const [thumbnailToDb, setThumbnailToDb] = useState("");

  // get content details
  const GetContentDetails = async () => {
    let response = await fetch(
      Variables.API_URL + "Content/GetContentDetails/" + contentId,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      }
    );
    let result = await response.json();
    if (response.status === 200) {
      setContentDetails({
        ContentId: result.Details.ContentId,
        Title: result.Details.Title,
        SubTitle: result.Details.SubTitle,
        Date: result.Details.Date.split("T")[0],
        MenuId: result.Details.MenuId,
        AlbumId: result.Details.AlbumId,
        HasEventDate: result.Details.HasEventDate,
        EventStartDate: result.Details.EventStartDate.split("T")[0],
        EventEndDate: result.Details.EventEndDate.split("T")[0],
        Description: result.Details.Description,
        SmallDescription: result.Details.SmallDescription,
        IsPublished: result.Details.IsPublished,
        ImageUrl: result.Details.ImageUrl,
        ThumbnailUrl: result.Details.ThumbnailUrl,
        AuthorId: result.Details.AuthorId,
        LanguageId: result.Details.LanguageId,
        ReferenceNumber: result.Details.ReferenceNumber,
        Dimension: result.Details.Dimension,
        MetaTitle: result.Details.MetaTitle,
        MetaDescription: result.Details.MetaDescription,
        MetaKeyword: result.Details.MetaKeyword,
      });
      setSelectedWidgets(result.Widgets);

      setContentExist(true);
    } else {
      setContentExist(false);
    }
  };

  // handle Inputs
  const handleInputs = (e) => {
    const { name, value } = e.target;
    var element;
    if (value === "" || value === "0") {
      element = document.getElementById(name);
      element.classList.add("is-invalid");
    } else {
      element = document.getElementById(name);
      element.classList.remove("is-invalid");
    }
    setContentDetails((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  // Set Image
  const SetImage = (e) => {
    var x = e.target.files[0];
    let reader = new FileReader();
    reader.onload = function (e) {
      if (
        e.target.result.indexOf("png") >= 0 ||
        e.target.result.indexOf("jpeg") >= 0 ||
        e.target.result.indexOf("jpg") >= 0
      ) {
        setImageToDb(x);
        setImage(e.target.result);
      } else {
        toast.error("File type error", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
    };
    reader.readAsDataURL(e.target.files[0]);
    var element = document.getElementById("ImageUrl");
    element.classList.remove("is-invalid");
  };

  // Set Thumbnail
  const SetThumbnail = (e) => {
    var x = e.target.files[0];
    let reader = new FileReader();
    reader.onload = function (e) {
      if (
        e.target.result.indexOf("png") >= 0 ||
        e.target.result.indexOf("jpeg") >= 0 ||
        e.target.result.indexOf("jpg") >= 0
      ) {
        setThumbnailToDb(x);
        setThumbnail(e.target.result);
      } else {
        toast.error("File type error", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
    };
    reader.readAsDataURL(e.target.files[0]);
    var element = document.getElementById("ThumbnailUrl");
    element.classList.remove("is-invalid");
  };

  // Handle Has Event Date
  const HandleHasEventDate = () => {
    if (contentDetails.HasEventDate === true) {
      setContentDetails((prevState) => ({
        ...prevState,
        HasEventDate: false,
      }));
    } else {
      setContentDetails((prevState) => ({
        ...prevState,
        HasEventDate: true,
      }));
    }
  };

  // Handle IsPublished
  const HandleIsPublished = () => {
    if (contentDetails.IsPublished === true) {
      setContentDetails((prevState) => ({
        ...prevState,
        IsPublished: false,
      }));
    } else {
      setContentDetails((prevState) => ({
        ...prevState,
        IsPublished: true,
      }));
    }
  };

  //#endregion

  // Check input validity
  function IsValid() {
    var hasError = false;
    var element;
    if (contentDetails.Title === null || contentDetails.Title === "") {
      element = document.getElementById("Title");
      element.classList.add("is-invalid");
      element.focus();
      hasError = true;
    }
    // if (contentDetails.SubTitle === null || contentDetails.SubTitle === "") {
    //   element = document.getElementById("SubTitle");
    //   element.classList.add("is-invalid");
    //   element.focus();
    //   hasError = true;
    // }
    if (contentDetails.Date === null || contentDetails.Date === "") {
      element = document.getElementById("Date");
      element.classList.add("is-invalid");
      element.focus();
      hasError = true;
    }
    if (contentDetails.MenuId === null || contentDetails.MenuId === 0) {
      element = document.getElementById("MenuId");
      element.classList.add("is-invalid");
      element.focus();
      hasError = true;
    }
    if (contentDetails.LanguageId === null || contentDetails.LanguageId === 0) {
      element = document.getElementById("LanguageId");
      element.classList.add("is-invalid");
      element.focus();
      hasError = true;
    }

    if (selectedTypes.length > 0) {
      let counter = 0;
      selectedTypes.forEach((element) => {
        if (element.SelectedData == 0) {
          element = document.getElementById("CustomFieldData" + counter);
          element.classList.add("is-invalid");
          element.focus();
          hasError = true;
        }
        counter++;
      });
    }

    if (hasError === true) {
      return false;
    } else {
      return true;
    }
  }

  function getDateFromDetails(x) {
    var x = contentDetails.EventStartDate.split("-");
    return new Date(x[0], x[1], x[2]);
  }

  // Add new Content
  const AddNewContent = async () => {
    setButtonLoader(true);
    let response = await fetch(Variables.API_URL + "Content/AddContent", {
      method: "POST",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        Details: contentDetails,
        Widgets: selectedWidgets,
        SelectedTypes: selectedTypes,
      }),
    });
    let result = await response.json();
    if (response.status === 200) {
      toast.success("Content Added Successfully", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });

      if (imageToDb != "") {
        const formData = new FormData();
        formData.append("Image", imageToDb);
        formData.append("ContentId", result);
        formData.append("Type", "MainImage");

        const resImage = await axios.post(
          Variables.API_URL + "Content/UploadContentMedia",
          formData, {
          headers: {
            Authorization: `Bearer ${token}`,
          }
        }
        );
      }

      if (thumbnailToDb != "") {
        const formData2 = new FormData();
        formData2.append("Image", thumbnailToDb);
        formData2.append("ContentId", result);
        formData2.append("Type", "ThumbnailImage");

        const resThumbnail = await axios.post(
          Variables.API_URL + "Content/UploadContentMedia",
          formData2, {
          headers: {
            Authorization: `Bearer ${token}`,
          }
        }
        );
      }



      setTimeout(() => {
        navigate("/Content");
      }, 1000);
    } else {
      toast.error(result, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
    setButtonLoader(false);
  };

  // Add new Content
  const UpdateContent = async () => {
    setButtonLoader(true);
    let response = await fetch(Variables.API_URL + "Content/UpdateContent", {
      method: "POST",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        Details: contentDetails,
        Widgets: selectedWidgets,
        SelectedTypes: selectedTypes,
      }),
    });
    let result = await response.json();
    if (response.status === 200) {
      toast.success(result, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });

      if (imageToDb != "") {
        const formData = new FormData();
        formData.append("Image", imageToDb);
        formData.append("ContentId", contentId);
        formData.append("Type", "MainImage");

        const resImage = await axios.post(
          Variables.API_URL + "Content/UploadContentMedia",
          formData, {
          headers: {
            Authorization: `Bearer ${token}`,
          }
        }
        );
      }

      if (thumbnailToDb != "") {
        const formData2 = new FormData();
        formData2.append("Image", thumbnailToDb);
        formData2.append("ContentId", contentId);
        formData2.append("Type", "ThumbnailImage");

        const resThumbnail = await axios.post(
          Variables.API_URL + "Content/UploadContentMedia",
          formData2, {
          headers: {
            Authorization: `Bearer ${token}`,
          }
        }
        );
      }
      setTimeout(() => {
        navigate("/Content");
      }, 1000);
    } else {
      toast.error(result, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
    setButtonLoader(false);
  };

  // Handle Sumbit
  const HandleSumbit = async () => {
    var isValid = IsValid();
    if (isValid) {
      // case of insert
      if (contentId === 0) {
        AddNewContent();
      }
      // case of update
      else {
        UpdateContent();
      }
    } else {
      toast.error("Please Fill All Required Fields", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        draggable: true,
        progress: undefined,
      });
    }
  };

  useEffect(() => {

    GetLanguages();
    GetMenus();
    GetAuthors();
    GetAlbums();
    GetWidgets();
    GetTypes();
    if (contentId != 0) {
      GetSelectedWidgets();
      GetContentDetails();
      GetSelectedTypes();
    }
  }, []);


  return (
    <div>
      <Row>
        <Col sm="12">
          <Card>
            <Card.Header className="d-flex justify-content-between">
              <div className="header-title">
                <h4 className="card-title">
                  {contentId === 0
                    ? "Add New Content"
                    : "Manage Content --> " + contentDetails.Title}
                </h4>
              </div>
            </Card.Header>
            <Card.Body>
              {loader === true ? (
                <CustomSnipper />
              ) : (
                <div>
                  <Row>
                    <Form.Group className="col-md-6 form-group">
                      <Form.Label htmlFor="fname">Title :</Form.Label>
                      <Form.Control
                        id="Title"
                        name="Title"
                        placeholder="Title"
                        type="text"
                        value={contentDetails.Title}
                        onChange={handleInputs}
                      />
                    </Form.Group>

                    <Form.Group className="col-md-6 form-group">
                      <Form.Label htmlFor="fname">SubTitle :</Form.Label>
                      <Form.Control
                        id="SubTitle"
                        name="SubTitle"
                        placeholder="SubTitle"
                        type="text"
                        value={contentDetails.SubTitle}
                        onChange={handleInputs}
                      />
                    </Form.Group>

                    <Form.Group className="col-md-6 form-group">
                      <Form.Label htmlFor="fname">Date :</Form.Label>
                      <Form.Control
                        id="Date"
                        name="Date"
                        placeholder="Date"
                        type="Date"
                        value={contentDetails.Date}
                        onChange={handleInputs}
                      />
                    </Form.Group>

                    <Form.Group className="col-md-6 form-group">
                      <Form.Label htmlFor="fname">Menu :</Form.Label>
                      <select
                        className="form-control"
                        name="MenuId"
                        id="MenuId"
                        value={contentDetails.MenuId}
                        onChange={handleInputs}
                      >
                        <option key={0} value={0}>
                          -- Select Menu Section --
                        </option>
                        {menus.map((x) => {
                          return (
                            <option key={x.MenuId} value={x.MenuId}>
                              {x.MenuTitle}
                            </option>
                          );
                        })}
                      </select>
                    </Form.Group>

                    <Form.Group className="col-md-6 form-group">
                      <Form.Label htmlFor="fname">Album :</Form.Label>
                      <select
                        className="form-control"
                        name="AlbumId"
                        id="AlbumId"
                        value={contentDetails.AlbumId}
                        onChange={handleInputs}
                      >
                        <option key={0} value={0}>
                          -- Select Album Section --
                        </option>
                        {albums.map((x) => {
                          return (
                            <option key={x.AlbumId} value={x.AlbumId}>
                              {x.AlbumName}
                            </option>
                          );
                        })}
                      </select>
                    </Form.Group>

                    <Form.Group className="col-md-12 form-group">
                      <Form.Label htmlFor="fname">
                        Assign To Widgets :
                      </Form.Label>
                      <Multiselect
                        options={widgets.Items} // Options to display in the dropdown
                        selectedValues={selectedWidgets} // Preselected value to persist in dropdown
                        displayValue="WidgetName" // Property name to display in the dropdown options
                        placeholder="Assign Widgets"
                        id="SelectedWidgets"
                        name="SelectedWidgets"
                        onSelect={handleAssignWdgets}
                        onRemove={handleAssignWdgets}
                      />
                    </Form.Group>

                    <Form.Group className="col-md-3 form-group">
                      <Form.Label htmlFor="fname">.</Form.Label>
                      <Form.Check className="mb-3 form-check">
                        <FormCheck.Input
                          type="checkbox"
                          className=""
                          id="Published"
                          checked={contentDetails.IsPublished}
                          onChange={(e) => HandleIsPublished()}
                        />
                        <FormCheck.Label className="" htmlFor="exampleCheck1">
                          IsPublished
                        </FormCheck.Label>
                      </Form.Check>
                    </Form.Group>

                    <Form.Group className="col-md-3 form-group">
                      <Form.Label htmlFor="fname">.</Form.Label>
                      <Form.Check className="mb-3 form-check">
                        <FormCheck.Input
                          type="checkbox"
                          className=""
                          id="HasEventDate"
                          checked={contentDetails.HasEventDate}
                          onChange={(e) => HandleHasEventDate()}
                        />
                        <FormCheck.Label className="" htmlFor="exampleCheck1">
                          Has Event Date
                        </FormCheck.Label>
                      </Form.Check>
                    </Form.Group>

                    {contentDetails.HasEventDate === true && (
                      <>
                        <Form.Group className="col-md-6 form-group">
                          <Form.Label htmlFor="fname">
                            Event Start Date :
                          </Form.Label>
                          <Form.Control
                            id="EventStartDate"
                            name="EventStartDate"
                            placeholder="Event Start Date"
                            type="Date"
                            value={contentDetails.EventStartDate}
                            onChange={handleInputs}
                          />
                        </Form.Group>

                        <Form.Group className="col-md-6 form-group">
                          <Form.Label htmlFor="fname">
                            Event End Date :
                          </Form.Label>
                          <Form.Control
                            id="EventEndDate"
                            name="EventEndDate"
                            placeholder="Event End Date"
                            type="Date"
                            value={contentDetails.EventEndDate}
                            onChange={handleInputs}
                          />
                        </Form.Group>
                      </>
                    )}

                    <Form.Group className="col-md-6 form-group">
                      <Form.Label htmlFor="fname">Description :</Form.Label>
                      <textarea
                        className="form-control"
                        aria-label="With textarea"
                        id="Description"
                        name="Description"
                        placeholder="Description"
                        type="textarea"
                        value={contentDetails.Description}
                        onChange={handleInputs}
                      ></textarea>
                    </Form.Group>

                    <Form.Group className="col-md-6 form-group">
                      <Form.Label htmlFor="fname">
                        Small Description :
                      </Form.Label>
                      <textarea
                        className="form-control"
                        aria-label="With textarea"
                        id="SmallDescription"
                        name="SmallDescription"
                        placeholder="Small Description"
                        type="textarea"
                        value={contentDetails.SmallDescription}
                        onChange={handleInputs}
                      ></textarea>
                    </Form.Group>

                    <Form.Group className="col-lg-6 col-md-12 col-sm-12 form-group">
                      <Row>
                        <Form.Group>
                          <Form.Label className="custom-file-input">
                            Choose Image
                          </Form.Label>
                          <Form.Control
                            id="ImageUrl"
                            name="ImageUrl"
                            placeholder="Image"
                            type="file"
                            accept="image/*"
                            onChange={SetImage}
                          />
                        </Form.Group>
                      </Row>
                      <Row>
                        <Col className="allignCenter">
                          {image !== "" ? (
                            <div>
                              <img
                                src={image}
                                className="w-100 shadow-1-strong rounded mb-4 img-200 image-log sqaureImage"
                                alt="Boat on Calm Water"
                              />
                            </div>
                          ) : contentDetails.ImageUrl !== "" &&
                            contentDetails.ImageUrl !== null ? (
                            <div>
                              <img
                                src={
                                  Variables.imagePath + contentDetails.ImageUrl
                                }
                                className="w-100 shadow-1-strong rounded mb-4 img-200 image-log sqaureImage"
                                alt="Boat on Calm Water"
                              />
                            </div>
                          ) : (
                            ""
                          )}
                        </Col>
                      </Row>
                    </Form.Group>

                    <Form.Group className="col-lg-6 col-md-12 col-sm-12 form-group">
                      <Row>
                        <Form.Group>
                          <Form.Label className="custom-file-input">
                            Choose Thumbnail
                          </Form.Label>
                          <Form.Control
                            id="ThumbnailUrl"
                            name="ThumbnailUrl"
                            placeholder="Choose Thumbnail"
                            type="file"
                            accept="image/*"
                            onChange={SetThumbnail}
                          />
                        </Form.Group>
                      </Row>
                      <Row>
                        <Col className="allignCenter">
                          {thumbnail !== "" ? (
                            <div>
                              <img
                                src={thumbnail}
                                className="w-100 shadow-1-strong rounded mb-4 img-200 image-log sqaureImage"
                                alt="Boat on Calm Water"
                              />
                            </div>
                          ) : contentDetails.ThumbnailUrl !== "" &&
                            contentDetails.ThumbnailUrl !== null ? (
                            <div>
                              <img
                                src={
                                  Variables.imagePath +
                                  contentDetails.ThumbnailUrl
                                }
                                className="w-100 shadow-1-strong rounded mb-4 img-200 image-log sqaureImage"
                                alt="Boat on Calm Water"
                              />
                            </div>
                          ) : (
                            ""
                          )}
                        </Col>
                      </Row>
                    </Form.Group>

                    <Row>
                      <Form.Group className="col-md-6 form-group">
                        <Form.Label htmlFor="ReferenceNumber">Reference number :</Form.Label>
                        <Form.Control
                          id="ReferenceNumber"
                          name="ReferenceNumber"
                          placeholder="Reference number"
                          type="text"
                          value={contentDetails.ReferenceNumber}
                          onChange={handleInputs}
                        />
                      </Form.Group>

                      <Form.Group className="col-md-6 form-group">
                        <Form.Label htmlFor="Dimension">Dimension :</Form.Label>
                        <Form.Control
                          id="Dimension"
                          name="Dimension"
                          placeholder="Dimension"
                          type="text"
                          value={contentDetails.Dimension}
                          onChange={handleInputs}
                        />
                      </Form.Group>
                    </Row>

                    <Form.Group className="col-md-12 form-group">
                      <Row>
                        <Form.Group className="col-md-12 form-group">
                          <Form.Label htmlFor="fname">
                            Add Custom Field Type :
                          </Form.Label>
                          <Multiselect
                            options={types} // Options to display in the dropdown
                            selectedValues={selectedTypes} // Preselected value to persist in dropdown
                            displayValue="Text" // Property name to display in the dropdown options
                            placeholder="Selected Custom Type"
                            id="selectedCustomType"
                            name="selectedCustomType"
                            onSelect={handleSelectType}
                            onRemove={handleRemoveType}
                          />
                        </Form.Group>
                        {selectedTypes.map((type, index) => (
                          <Form.Group
                            className="col-md-4 form-group"
                            key={index}
                          >

                            <Form.Label htmlFor="fname">{type.Text}</Form.Label>
                            <select
                              className="form-control"
                              name={"CustomFieldData" + index}
                              id={"CustomFieldData" + index}
                              value={type.SelectedData}
                              defaultValue={type.SelectedData}
                              onChange={(e) => handleSelectCustumData(e, index)}
                            >
                              <option key={0} value={0}>
                                -- Select {type.Text} --
                              </option>
                              {type.Data.map((x) => {
                                return (
                                  <option
                                    key={x.CustomFieldDataId}
                                    value={x.CustomFieldDataId}
                                  >
                                    {x.Text}
                                  </option>
                                );
                              })}
                            </select>
                          </Form.Group>
                        ))}
                      </Row>
                    </Form.Group>
                  </Row>

                  <Form.Group className="col-md-12 form-group">
                    <Form.Label htmlFor="fname">Meta Title:</Form.Label>
                    <textarea
                      className="form-control"
                      id="MetaTitle"
                      name="MetaTitle"
                      placeholder="Meta Title"
                      type="textarea"
                      value={contentDetails.MetaTitle}
                      onChange={handleInputs}
                    ></textarea>
                  </Form.Group>

                  <Form.Group className="col-md-12 form-group">
                    <Form.Label htmlFor="fname">Meta Description:</Form.Label>
                    <textarea
                      className="form-control"
                      id="MetaDescription"
                      name="MetaDescription"
                      placeholder="Meta Description"
                      type="textarea"
                      value={contentDetails.MetaDescription}
                      onChange={handleInputs}
                    ></textarea>
                  </Form.Group>

                  <Form.Group className="col-md-12 form-group">
                    <Form.Label htmlFor="fname">Meta Keyword :</Form.Label>
                    <textarea
                      className="form-control"
                      id="MetaKeyword"
                      name="MetaKeyword"
                      placeholder="Meta Keyword"
                      type="textarea"
                      value={contentDetails.MetaKeyword}
                      onChange={handleInputs}
                    ></textarea>
                  </Form.Group>

                </div>
              )}
              <hr />

              <div className="float-right">
                <Button
                  type="button"
                  variant="btn btn-primary"
                  onClick={HandleSumbit}
                >
                  {buttonLoader == true ? (
                    <Spinner animation="border" variant="light" role="status">
                      <span className="visually-hidden">Loading...</span>
                    </Spinner>
                  ) : (
                    "Submit"
                  )}
                </Button>{" "}
                <Button
                  type="button"
                  variant="btn btn-secondary"
                  onClick={() => navigate("/Content")}
                >
                  Cancel
                </Button>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={true}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </div>
  );
}

export default ManageContent;
